export default {
    'Coles Cars t': {
        affiliateUserId: 43226,
        displayName: "Coles Cars"
    },
    'Wilds Motors': {
        affiliateUserId: 43226,
        displayName: "Coles Cars"
    },
}